import { render, staticRenderFns } from "./ReModal.vue?vue&type=template&id=b10df8f0&"
import script from "./ReModal.vue?vue&type=script&lang=js&"
export * from "./ReModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports